import { idTypeV2Map, ticketStatus2Map, ticketStatusMap } from '@/dicts/order'
import { mapFilter } from './util'

export function certificateType (value) {
  return mapFilter(value, idTypeV2Map)
}

export function ticketStatus2 (value) {
  return mapFilter(value, ticketStatus2Map)
}

export function ticketStatus (value) {
  return mapFilter(value, ticketStatusMap)
}
